import React, {useState, useEffect}  from "react";
import {FaBars} from 'react-icons/fa'
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks, NavBtn, NavBtnLink, HeadLogo } from "./NavbarElements";
import {IconContext} from 'react-icons/lib';
import {animateScroll as scroll } from 'react-scroll';
import logo from '../../images/Logo_header.png';


const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = ()=> {
    if(window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
  window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <>
    <IconContext.Provider value={{color: '#fff' }}> 
      <Nav scrollNav={scrollNav}>
        <NavbarContainer>
          <NavLogo to="/" onClick={toggleHome}> <HeadLogo src={logo} alt="Logo" /></NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <NavMenu>
          <NavItem>
              <NavLinks to="aboutus" smooth={true} duration={700} spy={true} exact='true' offset={10}>About Us</NavLinks>
            </NavItem>
          <NavItem>
              <NavLinks to="ourclients" smooth={true} duration={700} spy={true} exact='true' offset={10}>Our Clients</NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks to="jobs" smooth={true} duration={700} spy={true} exact='true' offset={10} >Jobs</NavLinks>
            </NavItem>
          </NavMenu>
          <NavBtn>
            <NavBtnLink to="contactus" >Contact Us</NavBtnLink>
          </NavBtn>
        </NavbarContainer>
      </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
